/* @flow */

import * as React from 'react';

import './page-content-two-column.css';

type Props = {leftContent: React.Node, rightContent: React.Node};

export function PageContentTwoColumn(props: Props) {
    return (
        <div styleName='container'>
            <div styleName='left-container'>{props.leftContent}</div>
            <div styleName='right-container'>{props.rightContent}</div>
        </div>
    );
}
